import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import SelectorDirect from '@bubble-ui/molecule-selector-direct';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var SelectorActionsheet = _ref => {
  var {
      options
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  useDeprecationWarning({
    componentName: 'SelectorActionsheet',
    removalDate: 'v6.0.0',
    useInstead: "SelectorDirect' with property 'noRightIcon"
  });
  var opts = options.map(opt => _objectSpread(_objectSpread({}, opt), {}, {
    noRightIcon: true
  }));
  return /*#__PURE__*/React.createElement(SelectorDirect, _extends({
    options: opts
  }, rest));
};
SelectorActionsheet.displayName = 'SelectorActionsheet';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0. Use SelectorDirect with 'noRightIcon' property for every option instead.
 */
export default SelectorActionsheet;
//# sourceMappingURL=index.js.map